import { Pipe, PipeTransform } from '@angular/core';
import { InstructionType } from '@app/enums/instruction-type.enum';

@Pipe({
  name: 'layoutColumn',
  standalone: false,
})
export class LayoutColumnPipe implements PipeTransform {
  /**
   * Allow the content to take full width or half width based on condition.
   * @param instructionType - instruction type to transform to new display type else empty string, if not shown.
   * @param layoutFlag - Optional. Layout flag will be used to set a flag.
   * @returns transformed instruction css name string for handling column width.
   */
  public transform(instructionType: string, layoutFlag?: string): string {
    switch (instructionType) {
      case InstructionType.E_LEARNING:
      case InstructionType.INSTRUCTOR_LED_VIRTUAL:
      case InstructionType.INSTRUCTOR_LED_IN_PERSON:
      case InstructionType.INSTRUCTOR_LED:
      case InstructionType.SELF_STUDY:
      case InstructionType.QUICK_LEARNING:
      case InstructionType.WEBINAR:
      case InstructionType.WORKSHOP:
        if (layoutFlag === 'column') {
          return 'full-column-width';
        } else {
          return 'tile-layout-3';
        }
      case InstructionType.CERTIFICATION_EXAM:
        if (layoutFlag === 'column') {
          return 'columns';
        } else {
          return 'tile-layout-2';
        }
      default:
        return '';
    }
  }
}
